import React from "react";
import { Route, Switch } from "react-router-dom";
import LogisticPage from "../../pages/LogisticPage";
import PrivateRoute from "./privateRoute";
import DashboardPage from "../../pages/DashboardPage";
import ProtectedRoute from "./protectedRoute";
import {
  // BY_CLIENTS_PATH,
  CMR_PATH,
  CONTRACTS_PATH,
  CREATED_DECLARANTS_PATH,
  DELETED_DECLARANTS_PATH,
  DEPARTMENTS_DATA_PATH,
  HOMEPAGE_PATH,
  LOGIN_PATH,
  LOGISTIC_PATH,
  RESET_PASSWORD_PATH,
  SIGMA_PATH,
  FLEET_EXPENSES_PATH,
} from "../../constants/auth";
import LoginPage from "../../pages/LoginPage";
import CreatedPage from "../../pages/CreatedPage";
import DeletedPage from "../../pages/DeletedPage";
import DepartmentsDataPage from "../../pages/DepartmentsDataPage";
import ResetPasswordPage from "../../pages/ResetPasswordPage";
import NotFoundPage from "../../pages/errors/NotFoundPage";
// import ByClientsPage from "../../pages/ByClientsPage";
import CmrPage from "../../pages/CmrPage";
import {
  // ACCESS_TO_BY_CLIENTS,
  HAS_ACCESS_TO_CMR,
  ACCESS_TO_DEPARTMENTS_DATA,
  ACCESS_TO_FLEET_EXPENSES,
  DELETE_DECLARANT,
  ROLE_DECLARANT,
  ROLE_ADMIN,
  ROLE_EMPLOYEE,
} from "../../constants/authorize";
import SigmaPage from "../../pages/SigmaPage";
import Layout from "../Layout";
import ContractsPage from "pages/ContractsPage";
import FleetExpensesPage from "../../pages/FleetExpensesPage";

const Routes: React.FC = () => {
  return (
    <Layout>
      <Switch>
        <PrivateRoute
          path={HOMEPAGE_PATH}
          // @ts-ignore
          renderComponent={DashboardPage}
          exact
        />
        <PrivateRoute
          path={SIGMA_PATH}
          // @ts-ignore
          renderComponent={SigmaPage}
          exact
        />
        <PrivateRoute
          path={CREATED_DECLARANTS_PATH}
          // @ts-ignore
          renderComponent={CreatedPage}
        />
        <PrivateRoute
          path={DELETED_DECLARANTS_PATH}
          // @ts-ignore
          renderComponent={DeletedPage}
          authorizeByPermission={[DELETE_DECLARANT]}
        />
        <PrivateRoute
          path={DEPARTMENTS_DATA_PATH}
          // @ts-ignore
          renderComponent={DepartmentsDataPage}
          authorizeByPermission={[ACCESS_TO_DEPARTMENTS_DATA]}
        />
        {/*<PrivateRoute*/}
        {/*  path={BY_CLIENTS_PATH}*/}
        {/*  // @ts-ignore*/}
        {/*  renderComponent={ByClientsPage}*/}
        {/*  authorizeByPermission={[ACCESS_TO_BY_CLIENTS]}*/}
        {/*/>*/}
        {/*<PrivateRoute*/}
        {/*  path={CASHBOX_PATH}*/}
        {/*  // @ts-ignore*/}
        {/*  renderComponent={CashboxPage}*/}
        {/*  authorizeByPermission={[WORK_WITH_CASH]}*/}
        {/*/>*/}
        <PrivateRoute
          path={CMR_PATH}
          // @ts-ignore
          renderComponent={CmrPage}
          authorizeByPermission={[HAS_ACCESS_TO_CMR]}
          exact
        />
        <PrivateRoute
          path={LOGISTIC_PATH}
          // @ts-ignore
          renderComponent={LogisticPage}
          exact
        />
        <PrivateRoute
          path={CONTRACTS_PATH}
          // @ts-ignore
          renderComponent={ContractsPage}
          authorizeByRole={[ROLE_ADMIN, ROLE_EMPLOYEE, ROLE_DECLARANT]}
          exact
        />
        <PrivateRoute
          path={FLEET_EXPENSES_PATH}
          // @ts-ignore
          renderComponent={FleetExpensesPage}
          authorizeByPermission={[ACCESS_TO_FLEET_EXPENSES]}
          exact
        />
        <ProtectedRoute path={LOGIN_PATH} renderComponent={LoginPage} exact />
        <ProtectedRoute
          path={RESET_PASSWORD_PATH}
          renderComponent={ResetPasswordPage}
          exact
        />
        <Route component={NotFoundPage} />
      </Switch>
    </Layout>
  );
};

export default Routes;
